import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/app/error.tsx");
